import React from 'react';
import { Container }  from 'semantic-ui-react'

export default (props) => (
  <Container>
    <h2>Getting Started</h2>
    <p>Sample data. You can modify this static content in `/dev-portal/src/pages/GettingStarted/index.js` folder.</p>
  </Container>
);
